<template>
    <div>
    <div v-show="!table" class="text-center mt-5">
        <div class="spinner-border align-middle" role="status">
            <span class="sr-only">{{ $t('Loading...') }}</span>
        </div>
    </div>
    <table v-show="table" class="table table-striped table-hover" style="width:100%">
        <thead>
        <tr class="form-group">
            <th class="px-1">
                <input class="form-control w-100" name="id" placeholder="#" type="text" @keyup="filterColumn">
            </th>
            <th class="px-1 date">
                <input class="form-control w-100" name="created_date" :placeholder="$t('Order date')" type="date" @change="filterColumn">
            </th>
            <th class="px-1">
                <input :placeholder="$t('User')" class="form-control w-100" name="user" type="text" @keyup="filterColumn">
            </th>
            <template v-if="requesterEnable">
                <th class="px-1">
                    <input :placeholder="$t('Requester')" class="form-control w-100" name="requester" type="text" @keyup="filterColumn">
                </th>
                <th class="hide"></th>
                <th class="px-1">
                    <select2 v-if="organisations.length" :options="organisations" :placeholder="$t('Organisation')" class="form-control" @change="filterOrganisation">
                    </select2>
                </th>
                <th class="px-1">
                    <input :placeholder="$t('Project')" class="form-control w-100" name="project" type="text" @keyup="filterColumn">
                </th>
            </template>
            <th class="px-1">
                <input :placeholder="$t('Sender')" class="form-control w-100" name="sender" type="text" @keyup="filterColumn">
            </th>
            <th class="px-1">
                <input :placeholder="$t('Recipient')" class="form-control w-100" name="recipient" type="text" @keyup="filterColumn">
            </th>
            <th class="px-1"></th>
            <th class="px-1"></th>
            <th class="px-1"></th>
            <th class="px-1"></th>
            <th class="px-1"></th>
            <th class="px-1"></th>
            <th class="px-1"></th>
            <th class="px-1"></th>
            <th class="px-1"></th>
            <th class="px-1"></th>
            <th class="px-1 date">
                <input class="form-control w-100" name="collection_date" :placeholder="$t('Collection date')" type="date" @change="filterColumn">
            </th>
            <th class="hide"></th>
            <th class="px-1">
                <select2 v-if="statuses.length" :options="statuses" :placeholder="$t('Status')" class="form-control" @change="filterStatus">
                </select2>
            </th>
            <th class="px-1"></th>
            <th class="px-1"></th>
        </tr>
        <tr>
            <th class="sticky-top bg-white">#</th>
            <th class="sticky-top bg-white">{{ $t('Order date') }}</th>
            <th class="sticky-top bg-white">{{ $t('User') }}</th>
            <template v-if="requesterEnable">
                <th class="sticky-top bg-white">{{ $t('Requester') }}</th>
                <th class="hide"></th>
                <th class="sticky-top bg-white">{{ $t('Organisation') }}</th>
                <th class="sticky-top bg-white">{{ $t('Project') }}</th>
            </template>
            <th class="sticky-top bg-white">{{ $t('Sender') }}</th>
            <th class="sticky-top bg-white">{{ $t('Recipient') }}</th>
            <th class="sticky-top bg-white">{{ $t('Parcel') }}</th>
            <th class="sticky-top bg-white">{{ $t('Category') }}</th>
            <th class="sticky-top bg-white">{{ $t('Subcategory') }}</th>
            <th class="sticky-top bg-white">{{ $t('Description') }}</th>
            <th class="sticky-top bg-white">{{ $t('Amount insured') }}</th>
            <th class="sticky-top bg-white">{{ $t('Price') }}</th>
            <th class="sticky-top bg-white">{{ $t('Courier') }}</th>
            <th class="sticky-top bg-white">{{ $t('Service') }}</th>
            <th class="sticky-top bg-white">{{ $t('Transit') }}</th>
            <th class="sticky-top bg-white">{{ $t('Tracking code') }}</th>
            <th class="sticky-top bg-white">{{ $t('Collection date') }}</th>
            <th class="hide"></th>
            <th class="sticky-top bg-white">{{ $t('Status') }}</th>
            <th class="sticky-top bg-white">{{ $t('Actions') }}</th>
            <th class="sticky-top bg-white">{{ $t('Documents') }}</th>
        </tr>
        </thead>
    </table>
    </div>
</template>

<script>
import Select2 from "../Select2";

export default {
    name: "OrderTable",
    components: {Select2},
    props: {
        userShow: {type: Boolean, default: false},
        requesterEnable: {type: Boolean, default: false},
    },
    data() {
        return {
            table: undefined,
        }
    },
    computed: {
        orders() {
            return this.$store.state.order.orders;
        },
        organisations() {
            return [
                {id: 0, name: this.$t('Personal shipment')},
                ...this.$store.state.order.requester.organisations
            ];
        },
        statuses() {
            let statuses = this.$i18n.messages[this.$i18n.locale].status;

            return Object.keys(statuses).map(key => ({id: key, name: statuses[key]}));
        }
    },
    watch: {
        orders(orders) {
            this.table = $('table', this.$el).DataTable({
                language: this.$i18n.messages[this.$i18n.locale].datatables,
                data: orders,
                columns: [
                    {name: 'id', data: 'id', type: 'num'},
                    {name: 'created_date', data: 'created_date', type: 'date'},
                    {name: 'user', data: 'user', render: 'name', visible: this.userShow},
                    ...(!this.requesterEnable ? [] : [
                        {name: 'requester', data: 'requester', render: $.fn.dataTable.render.fullname()},
                        {name: 'organisation-id', data: item => item.requester?.organisation?.id ?? 0, type: 'num', visible: false},
                        {name: 'organisation', data: item => item.requester?.organisation?.name ?? null},
                        {name: 'project', data: item => item.requester?.project ?? null},
                    ]),
                    {name: 'sender', data: 'sender', render: $.fn.dataTable.render.address()},
                    {name: 'recipient', data: 'recipient', render: $.fn.dataTable.render.address()},
                    {data: 'parcel', render: $.fn.dataTable.render.parcel()},
                    {data: 'category', visible: false},
                    {data: 'subcategory', visible: false},
                    {data: 'description', visible: false},
                    {data: item => item.insurance.amount, render: $.fn.dataTable.render.currency()},
                    {data: item => item.price.total, render: $.fn.dataTable.render.currency()},
                    {data: item => item.service.courier, render: 'name'},
                    {data: 'service', render: 'name'},
                    {data: 'transit'},
                    {data: 'tracking_code'},
                    {name: 'collection_date', data: 'collection_date', type: 'date'},
                    {name: 'status-key', data: 'status', visible: false},
                    {name: 'status', data: 'status', render: this.renderStatus},
                    {name: 'actions', data: 'actions', render: this.renderActions},
                    {data: 'id', render: this.renderDocuments, sortable: false, class: 'no-export'},
                ],
                order: [[0, 'desc']],
                dom: "<'row'<'col-sm-12 col-md-6'<'d-flex align-items-baseline'B<'ml-2'l>>><'col-sm-12 col-md-6'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
                buttons: [
                    {
                        extend: 'collection',
                        text: this.$t('Export'),
                        buttons: [
                            {
                                extend: 'excel',
                                exportOptions: {
                                    columns: ':visible:not(.no-export)'
                                }
                            },
                            {
                                extend: 'csv',
                                exportOptions: {
                                    columns: ':visible:not(.no-export)'
                                }
                            },
                            {
                                extend: 'print',
                                exportOptions: {
                                    columns: ':visible:not(.no-export)'
                                }
                            },
                        ]
                    },
                    {
                        extend: 'colvis',
                        columns: ':not(.hide)',
                    },
                ]
            });
        }
    },
    methods: {
        filterColumn(event) {
            this.table.column(`${event.target.name}:name`).search(event.target.value).draw();
        },
        filterOrganisation(id) {
            this.table.column('organisation-id:name').search(`^${id}$`, true).draw();
        },
        filterStatus(key) {
            this.table.column('status-key:name').search(`^${key}$`, true).draw();
        },
        renderStatus(status) {
            let badge = 'secondary';

            if (['collection_scheduled', 'collected', 'delivered'].includes(status)) {
                badge = 'success';
            }

            if (status.endsWith('_error')) {
                badge = 'info';
            }

            if (status === 'payment_failed') {
                badge = 'danger';
            }

            if (status === 'canceled') {
                badge = 'primary';
            }

            let text = this.$t(`status.${status}`)

            return `<h5><span class="badge badge-${badge}">${text}</span></h5>`;
        },
        renderActions(actions, type, row) {
            let output = '';

            if (actions.cancel) {
                let confirmation = `return confirm('${this.$t('Are you sure you want to cancel the order?')}')`;
                output += `<a href="/order/${row.id}/cancel" class="btn btn-sm btn-danger" onclick="${confirmation}">${this.$t('Cancel')}</a>`;
            }

            return output;
        },
        renderDocuments(id, type, row) {
            let docs = [];

            if (row.has_label) {
                docs.push(this.renderLabel(id));
            }

            if (row.has_goods_declaration) {
                docs.push(this.renderGoodsDeclaration(id));
            }

            if (row.has_dual_use) {
                docs.push(this.renderDualUse(id));
            }

            if (row.has_cities) {
                docs.push(this.renderCities(id));
            }

            return docs.join(' ');
        },
        renderLabel(id) {
            let title = this.$t('Label');

            return `<a href="/order/${id}/doc/label"><i class="h1 fa fa-file-pdf" title="${title}"></i></a>`;
        },
        renderGoodsDeclaration(id) {
            let title = this.$t('Goods declaration');

            return `<a href="/order/${id}/doc/goods-declaration"><i class="h1 fa fa-file-pdf" title="${title}"></i></a>`;
        },
        renderDualUse(id) {
            let title = this.$t('Dual use');

            return `<a href="/order/${id}/doc/dual-use"><i class="h1 fa fa-file-pdf" title="${title}"></i></a>`;
        },
        renderCities(id) {
            return `<a href="/order/${id}/doc/cities"><i class="h1 fa fa-file-pdf" title="Cities"></i></a>`;
        },
    },
    mounted() {
        this.$store.dispatch('order/loadOrders');
        this.$store.dispatch("order/requester/loadOrganisations");
    }
}
</script>

<style scoped>
    table thead th.sticky-top {
        position: sticky !important;
        top: 70px;
    }
    table thead th.date {
        max-width: 8em;
    }
</style>
